// extracted by mini-css-extract-plugin
export default {"base-loader":"p2c931WE_7Ygw46oY8b2","v-progress-circular__underlay":"UyWT90ArX9gEBZg5e1Ko","v-progress-circular__overlay":"U34Jk9v5sRXvGML5izQ0"};